import type { ReactNode } from 'react';

export const symbol_arrow_menu_close: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M400-326 262-458q-9-9-9-22t9-22l138-132q8-7 16.5-3.5T425-624v288q0 10-8.5 13.5T400-326Zm140 176v-660q0-13 8.5-21.5T570-840q13 0 21.5 8.5T600-810v660q0 13-8.5 21.5T570-120q-13 0-21.5-8.5T540-150Z"
		/>
	</svg>
);
